module.exports = __webpack_public_path__ + "img/top.0dcd4234.png";